import { useFormikContext } from 'formik';

import React, { FC, useMemo } from 'react';
import { NewCentralFormType } from '../types';
import { Box, Checkbox, Grid } from '@material-ui/core';
import {
  SearchEntityEnum,
  searchEntityTypeLabel,
  searchEntityTypeList,
} from './search-v3-types';
import { getSearchSpaceIntersection } from './search-v3-utils';

type Props = {};

const SearchEntityTypesFilter: FC<Props> = () => {
  const { values, handleChange } = useFormikContext<NewCentralFormType>();
  const currentList = useMemo(
    () =>
      getSearchSpaceIntersection(
        values.specificFilterRows.map((r) => r.filterOption)
      ),
    [values]
  );

  return (
    <Box display="flex" justifyContent="space-between">
      {searchEntityTypeList.map((option) => {
        const disabled =
          Object.entries(values.includeSearchEntityTypes_V3 ?? {}).filter(
            (ob) => ob[0] !== option && ob[1]
          ).length < 1;

        const isPresent = currentList.includes(option as SearchEntityEnum);

        return (
          <Grid item xs={'auto'} key={option}>
            <Checkbox
              disabled={!isPresent || disabled}
              id={`includeSearchEntityTypes_V3.${option}`}
              checked={
                isPresent ? values.includeSearchEntityTypes_V3[option] : false
              }
              value={option}
              onChange={handleChange}
            />
            {searchEntityTypeLabel[option]}
          </Grid>
        );
      })}
    </Box>
  );
};
export default SearchEntityTypesFilter;
